import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { AbstractGotoSymbolQuickAccessProvider } from '../../../contrib/quickAccess/gotoSymbolQuickAccess.js';
import { Registry } from '../../../../platform/registry/common/platform.js';
import { Extensions } from '../../../../platform/quickinput/common/quickAccess.js';
import { ICodeEditorService } from '../../../browser/services/codeEditorService.js';
import { withNullAsUndefined } from '../../../../base/common/types.js';
import { QuickOutlineNLS } from '../../../common/standaloneStrings.js';
import { Event } from '../../../../base/common/event.js';
import { EditorAction, registerEditorAction } from '../../../browser/editorExtensions.js';
import { EditorContextKeys } from '../../../common/editorContextKeys.js';
import { IQuickInputService } from '../../../../platform/quickinput/common/quickInput.js';

var StandaloneGotoSymbolQuickAccessProvider = /*#__PURE__*/function (_AbstractGotoSymbolQu) {
  _inherits(StandaloneGotoSymbolQuickAccessProvider, _AbstractGotoSymbolQu);

  var _super = _createSuper(StandaloneGotoSymbolQuickAccessProvider);

  function StandaloneGotoSymbolQuickAccessProvider(editorService) {
    var _this;

    _classCallCheck(this, StandaloneGotoSymbolQuickAccessProvider);

    _this = _super.call(this);
    _this.editorService = editorService;
    _this.onDidActiveTextEditorControlChange = Event.None;
    return _this;
  }

  _createClass(StandaloneGotoSymbolQuickAccessProvider, [{
    key: "activeTextEditorControl",
    get: function get() {
      return withNullAsUndefined(this.editorService.getFocusedCodeEditor());
    }
  }]);

  return StandaloneGotoSymbolQuickAccessProvider;
}(AbstractGotoSymbolQuickAccessProvider);

StandaloneGotoSymbolQuickAccessProvider = __decorate([__param(0, ICodeEditorService)], StandaloneGotoSymbolQuickAccessProvider);
export { StandaloneGotoSymbolQuickAccessProvider };
Registry.as(Extensions.Quickaccess).registerQuickAccessProvider({
  ctor: StandaloneGotoSymbolQuickAccessProvider,
  prefix: AbstractGotoSymbolQuickAccessProvider.PREFIX,
  helpEntries: [{
    description: QuickOutlineNLS.quickOutlineActionLabel,
    prefix: AbstractGotoSymbolQuickAccessProvider.PREFIX,
    needsEditor: true
  }, {
    description: QuickOutlineNLS.quickOutlineByCategoryActionLabel,
    prefix: AbstractGotoSymbolQuickAccessProvider.PREFIX_BY_CATEGORY,
    needsEditor: true
  }]
});
export var GotoLineAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(GotoLineAction, _EditorAction);

  var _super2 = _createSuper(GotoLineAction);

  function GotoLineAction() {
    _classCallCheck(this, GotoLineAction);

    return _super2.call(this, {
      id: 'editor.action.quickOutline',
      label: QuickOutlineNLS.quickOutlineActionLabel,
      alias: 'Go to Symbol...',
      precondition: EditorContextKeys.hasDocumentSymbolProvider,
      kbOpts: {
        kbExpr: EditorContextKeys.focus,
        primary: 2048
        /* CtrlCmd */
        | 1024
        /* Shift */
        | 45
        /* KEY_O */
        ,
        weight: 100
        /* EditorContrib */

      },
      contextMenuOpts: {
        group: 'navigation',
        order: 3
      }
    });
  }

  _createClass(GotoLineAction, [{
    key: "run",
    value: function run(accessor) {
      accessor.get(IQuickInputService).quickAccess.show(AbstractGotoSymbolQuickAccessProvider.PREFIX);
    }
  }]);

  return GotoLineAction;
}(EditorAction);
registerEditorAction(GotoLineAction);